import React from 'react';
import UserMenu from './UserMenu';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
const QUERY = gql `
  query UserMenuLoaderQuery {
    viewer {
      id
      ...UserMenu_viewer
    }
  }
  ${UserMenu.fragments.viewer}
`;
const UserMenuLoader = (props) => {
    let { loading, error, data } = useQuery(QUERY);
    if (loading || !data)
        return React.createElement(UserMenu, { viewer: props.viewer });
    return React.createElement(UserMenu, { viewer: data.viewer });
};
export default UserMenuLoader;
